import React from 'react';
import PropTypes from 'prop-types';

const UserResultSelectedItem = props => (
  <li
    className="user-selection-item"
    style={{ backgroundColor: props.color, borderColor: props.color }}
    title={`${props.user.emailAddress} ${props.user.department}`}
  >
    {props.user.fullName}
    <a // eslint-disable-line
      className="user-close"
      title="Remove this user"
      onClick={() => props.removeSelectedUserClick(props.index)}
    >
      x
    </a>
  </li>
);

UserResultSelectedItem.propTypes = {
  user: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeSelectedUserClick: PropTypes.func.isRequired,
};

export default UserResultSelectedItem;
